//
//
//
//
//
//
//
//
//
//
//

  const iconMap = {
    success: 'icon-smile',
    error: 'icon-cry',
    cancel: 'icon-embarrass',
  };
  export default {
    name: 'Toast',
    data() {
      return {
        showValue: false,
      };
    },
    props: {
      value: Boolean,
      content: String,
      position: String,
      type: {
        type: String,
        default: 'text',
      },
      time: {
        type: Number,
        default: 2000,
      },
    },
    computed: {
      transition() {
        if (this.position === 'top') return 'slide-from-top';
        if (this.position === 'bottom') return 'slide-from-bottom';
        return 'fade';
      },
      positionClass() {
        if (this.position === 'top' || this.position === 'bottom') {
          return `toast-${this.position}`;
        }
        return 'toast-middle';
      },
      iconClass() {
        return iconMap[this.type];
      },
      showIcon() {
        return Object.keys(iconMap).indexOf(this.type) > -1;
      },
    },
    watch: {
      value(val) {
        this.showValue = val;
      },
      showValue(val) {
        this.$emit('input', val);
        if (val) {
          setTimeout(() => {
            this.showValue = !val;
          }, this.time);
        }
      },
    },
    created() {
      if (this.value) {
        this.showValue = this.value;
      }
    },
  };



// WEBPACK FOOTER //
// ./src/components/commons/Toast/index.vue